import React from 'react';
import {Container} from '@inlet/react-pixi';
import {IReactView} from '@gongxigames/framework/core/fragments/react/IReactView';
import {ReactMediator} from '@gongxigames/framework/core/fragments/react/ReactMediator';
import {Container as PixiContainer} from 'pixi.js';
import {System} from '@gongxigames/framework/core/services/system/System';
import {ComponentModuleViewConfig, DefaultEventsMap, ISystemComponent} from '@gongxigames/framework/core/types';
import {CoreDI} from '@gongxigames/framework/core/configs';
import {BaseView} from '@gongxigames/framework/slot/fragments/module/view';
import {inject} from '@gongxigames/framework/core/installer';
import {componentNameToString} from '@gongxigames/framework/core/utils/componentNameToString';

export abstract class ReactView<S extends Record<string, any>, E = DefaultEventsMap> extends BaseView<E> implements IReactView, ISystemComponent {
    protected get parent(): PixiContainer {
        return this._system.app.stageV1;
    }

    @inject(CoreDI.System)
    protected _system!: System;

    protected _reactMediator!: ReactMediator;

    public readonly container: PixiContainer = new PixiContainer();

    public state!: S;

    public render(): JSX.Element {
        return <Container name={'ReactView'}/>;
    }

    public destroy(): void {
        super.destroy();
        this.remove();
    }

    protected createReactMediator(): void {
        this._reactMediator = ReactMediator.fromReactView(this);
    }

    public init(): void {
        super.init();

        this.createReactMediator();
        this.addToParent();
    }

    protected setInitParameters(config: ComponentModuleViewConfig): void {
        this.container.name = componentNameToString(config.NAME);
        this.container.parentGroup = config.layer.group;
    }

    public show(): void {
        this.container.visible = true;
    }

    public hide(): void {
        this.container.visible = false;
    }

    public addToParent(): void {
        this.parent.addChild(this.container);
    }

    public removeFromParent(): void {
        this.container.parent?.removeChild(this.container);
    }

    public remove(): void {
        ReactMediator.unmountComponent(this.container);
        this.removeEvents();
        this.removeFromParent();
    }

    public isVisible(): boolean {
        return this.container.visible;
    }

    public forceUpdate(): void {
        this._reactMediator.forceUpdate();
    }

    public setState<K extends keyof S>(
        state: ((prevState: Readonly<S>, props: Readonly<any>) => (Pick<S, K> | S | null)) | (Pick<S, K> | S | null),
        callback?: () => void
    ): void {
        this._reactMediator.setState(state, callback);
    }

    public componentDidMount(): void {
    }

    public componentDidUpdate(): void {
    }

    public componentWillUnmount(): void {
    }
}
